import FetchUtils from '../utils/fetch.utils';

export default class PickupService {
  static BASE_URL = `${process.env.PREACT_APP_API_DOMAIN_PICKUPS}/api/pickup`;

  static listStores = async params => {
    const { organization: organizationCode } = params;

    return FetchUtils.get(
      `${PickupService.BASE_URL}/stores` +
        FetchUtils.getQueryParams({
          organizationCode,
        }),
    );
  };

  static listLocations = async params => {
    const {
      storeId = null,
      lat = null,
      long = null,
      organization: organizationCode,
    } = params;

    return FetchUtils.get(
      `${PickupService.BASE_URL}/stores/locations` +
        FetchUtils.getQueryParams({
          storeId,
          lat,
          long,
          organizationCode,
        }),
    );
  };
}
